/* global Greenhouse */

import Rollbar from 'rollbar/dist/rollbar.umd.min';
import _ from 'underscore';

const isWebpackStacktrace = function (stack) {
  const lines = stack.split('\n');
  const firstFewLines = lines.slice(0, 4);
  return _.find(firstFewLines, (line) => {
    return line.match(/assets\/webpack/);
  });
};

const isBrowserExtensionError = function (stack) {
  return (
    stack.includes('chrome-extension://') || stack.includes('moz-extension://')
  );
};

export const checkIgnore = (uncaught, rollbarReport) => {
  try {
    if (!uncaught) {
      return false;
    }
    const stack = rollbarReport[1].stack;
    if (isBrowserExtensionError(stack)) {
      return true;
    }
    return !isWebpackStacktrace(stack);
  } catch (e) {
    return true;
  }
};

const ROLLBAR_CONFIG = {
  captureUncaught: true,
  captureUnhandledRejections: true,
  checkIgnore: checkIgnore,
  enabled: window.__WEBPACK_SETUP_DATA__.rollbarEnabled,
  ignoredMessages: [
    /Cannot call drop while not dragging./,
    /Cannot read properties of undefined \(reading 'dragging'\)/i,
    /Cannot set properties of undefined \(setting 'dragging'\)/i,
    /<DraggableCore>: Unmounted during event!/i,
    // Duplicate noise from the frontend - if we are failing with a bad status code, we are liking to be seeing this on the backend.
    /Request failed with status code/,
    // Client-side network issues (e.g. flaky connectivity) cause Axios timeouts that are not actionable.
    /timeout exceeded/,
    // Navigating away aborts in-flight XHR requests, which is normal browser behavior.
    /Request aborted/,
    // Client-side network drops trigger Axios onerror with "Network Error", not actionable.
    /Network Error/,
  ],
  accessToken: window.__WEBPACK_SETUP_DATA__.rollbarClientAccessToken,
  payload: {
    client: {
      javascript: {
        code_version: window.__WEBPACK_SETUP_DATA__.gitSha,
        source_map_enabled: true,
      },
    },
    environment: !!__PROD__ ? 'production' : 'development',
    person: {
      id: Greenhouse?.userId,
    },
  },
};

const rollbar = new Rollbar(ROLLBAR_CONFIG);
export default rollbar;
